import { render, staticRenderFns } from "./perfSetSort.vue?vue&type=template&id=b3d33978&"
import script from "./perfSetSort.vue?vue&type=script&lang=js&"
export * from "./perfSetSort.vue?vue&type=script&lang=js&"
import style0 from "./perfSetSort.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "perfSetSort.vue"
export default component.exports